import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import SplashScreen from './components/SplashScreen';

import NettoyageVoiturePage from './pages/NettoyageVoiturePage';
import AvantApresPage from './pages/AvantApresPage';
import ProjectDetailsPage from './pages/ProjectDetailsPage';
import NettoyageMobiliersPage from './pages/NettoyageMobiliersPage';
import TarifsPage from './pages/TarifsPage';
import ContactPage from './pages/ContactPage';
import ReservationPage from './pages/ReservationPage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';
import LocalPage from './pages/LocalPage';
import ConfidentialitePage from './pages/ConfidentialitePage';

// Placeholder pages need top padding because Layout no longer provides it
const PageWrapper = ({ title }) => (
  <div className="page-container container">
    <div className="text-center">
      <h1 className="section-title">{title}</h1>
      <p>Page en construction...</p>
    </div>
  </div>
);

function App() {
  const [showSplash, setShowSplash] = React.useState(() => {
    // Check if splash has been shown before in this session (or ever)
    // Using sessionStorage would show it once per tab/session.
    // Using localStorage shows it once EVER.
    const hasShown = localStorage.getItem('roulez_propre_splash_shown');
    return !hasShown;
  });

  const handleFinishSplash = () => {
    setShowSplash(false);
    localStorage.setItem('roulez_propre_splash_shown', 'true');
  };

  // Prevent scrolling while splash is active
  React.useEffect(() => {
    if (showSplash) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showSplash]);

  return (
    <Router>
      <AnimatePresence mode="wait">
        {showSplash ? (
          <SplashScreen key="splash" onFinish={handleFinishSplash} />
        ) : (
          <>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="nettoyage-voiture" element={<NettoyageVoiturePage />} />
                <Route path="avant-apres" element={<AvantApresPage />} />
                <Route path="avant-apres/:projectId" element={<ProjectDetailsPage />} />
                <Route path="nettoyage-mobiliers" element={<NettoyageMobiliersPage />} />
                <Route path="reservation" element={<ReservationPage />} />
                <Route path="tarifs" element={<TarifsPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="confidentialite" element={<ConfidentialitePage />} />
                <Route path="nettoyage-auto/:city" element={<LocalPage />} />
                <Route path="*" element={<PageWrapper title="404 - Page non trouvée" />} />
              </Route>
              <Route path="profile" element={<ProfilePage />} />
              <Route path="admin" element={<AdminPage />} />
            </Routes>
          </>
        )}
      </AnimatePresence>
    </Router>
  );
}

export default App;
